import axios from "axios";
// import { localStorage.getItem } from 'cookies-next';

//axios.defaults.baseURL = "http://127.0.0.1:8000";

axios.defaults.baseURL = "https://backendmarket.ahrvo.com";

export const fetchCountries = async (data) => {
  const country = data?.selectedCountryNames ? data?.selectedCountryNames : "";
  const service = data?.selectedTypesNames ? data?.selectedTypesNames : "";
  const category = data?.selectedCategoryNames
    ? data?.selectedCategoryNames
    : "";
  const newpage = data?.newPage ? data?.newPage : data?.page;
  const page = newpage ? newpage : 1;

  console.log("data?.newpage", data?.newPage);

  try {
    const response = await axios.get(
      `/countries/?name=${country}&service=${service}&category=${category}&page=${page}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const fetchSingleCountry = async (data) => {
  const country = data?.selectedCountryNames ? data?.selectedCountryNames : "";
  const service = data?.selectedTypesNames ? data?.selectedTypesNames : "";
  const category = data?.selectedCategoryNames
    ? data?.selectedCategoryNames
    : "";

  try {
    const response = await axios.get(
      `/countries/?name=${country}&service=${service}&category=${category}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const fetchType = async () => {
  try {
    const response = await axios.get(`/type/`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const fetchService = async () => {
  try {
    const response = await axios.get(`/services/`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const fetchAllCountries = async (page) => {
  try {
    const response = await axios.get(`/countries_list/?page=${page}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const fetchSingleCountries = async (id) => {
  try {
    const response = await axios.get(`/countries/${id}/`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const searchTypes = async (data) => {
    try {
        const response = await axios.get(`/apm_search/?search=${data?.searchValue}&service=${data?.typeString}&page=${data?.newpage}`, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response;
    } catch (error) {
        return error.response;
    }
}

export const fetchBannerData = async () => {
  try {
    const response = await axios.get(`/get_logo/`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

// apm_descriptions

export const fetchAPMs = async (data) => {
  console.log("page", data.page);
  const service = data?.selectedTypesNames ? data?.selectedTypesNames : "";
  const category = data?.selectedCategoryNames
    ? data?.selectedCategoryNames
    : "";
  const page = data?.page ? data?.page : 1;
  try {
    const response = await axios.get(
      `/apm-descriptions/?service=${service}&category=${category}&page=${page}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

// get_countries/<str:apm_name>/
export const getCountryAPMs = async (data) => {
  try {
    const response = await axios.get(`/get_countries/${data}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const fetchNextAPMs = async (value) => {
  console.log("newLimt, offset", value);
  try {
    const response = await axios.get(`${value}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

// apm-descriptions/?id=50

export const fetchSingleAPMs = async (id) => {
  try {
    const response = await axios.get(`apm-descriptions/?id=${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

// /apm_togal/51/

export const fetchAPMsToggle = async (id, data) => {
  console.log("apm_toggle", id, data);
  try {
    const response = await axios.put(`apm_togal/${id}/`, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const fetchPaymentMethods = async (id) => {
  try {
    const response = await axios.get(`/random_apms/${id}/`);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const fetchApmPaymentMethods = async () => {

    try {
        const response = await axios.get(`/get_random_apms/`);
        return response;
    } catch (error) {
        return error.response;
    }
}


export const fetchRandomGateways = async () => {
    try {
        const response = await axios.get(`/get_random_gateway/`);
        return response;
    } catch (error) {
        return error.response;
    }
}

export const fetchDefaultSearchResult = async (value) => {
    try {
        const response = await axios.get(`/countries_list/?page=1&search=${value}`, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response;
    } catch (error) {
        return error.response;
    }
}
